module.exports = __webpack_public_path__ + "static/Brasil-0f1b8cfb7a0d878b5d0cff8eb67978e6.png";